module.exports = __webpack_public_path__ + "media/discovery-ui/assets/drop-placeholder-0b5c8c50c79fe864834f4f0fcd33adb8.svg";